import React from "react";
import {Canvas} from "@react-three/fiber";
import {Environment, ContactShadows, Stats} from "@react-three/drei";
import ModelsContainer from "./components/models/ModelsContainer";
import {useSnapshot} from 'valtio';
import {state} from './state';
import SaveImage from "./components/ui/controls/SaveImage";

const Scene = () => {
  
  const {showContactShadows, reset, background} = useSnapshot(state);
  

  return (
    
    <div className={"main-container " + background}>
      <div className="scene-container">
        {(!reset) && <Canvas gl={{ preserveDrawingBuffer: true }}>
          <SaveImage/>
          <ModelsContainer/>
          {/* <LightingContainer/> */}
          {/* <ambientLight intensity={1.1} /> */}
          {/* <directionalLight intensity={0.2} position={[30, 50, 30]} castShadow={true} shadow-mapSize-height={1024} shadow-mapSize-width={1024} /> */}
          {/* <directionalLight intensity={0.2} position={[-30, 50, 30]} castShadow={true} shadow-mapSize-height={1024} shadow-mapSize-width={1024} /> */}
          {/* <directionalLight intensity={0.2} position={[-30, 50, -30]} castShadow={true} shadow-mapSize-height={1024} shadow-mapSize-width={1024} /> */}
          {/* <directionalLight intensity={0.2} position={[30, 50, -30]} castShadow={true} shadow-mapSize-height={1024} shadow-mapSize-width={1024} /> */}
          <pointLight intensity={1} position={[50, 10, 10]}/>
          <pointLight intensity={1} position={[-50, 10, 10]}/>
          {(showContactShadows) && <ContactShadows opacity={0.4} scale={20} blur={1} far={10} resolution={256} color="#000000" />}
          
          <Environment
            background={false}
            /* preset={"park"} */
            files={"./kloppenheim_05_puresky_2k.hdr"}
            path={'./'}
          />
            
        </Canvas>}
        {/* <Stats/> */}
      </div>
    </div>
  );
  
}

export default Scene;
